import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, take } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';
import { PaymentService } from '@services';
import { selectRouteState } from '@state/route';
import * as PaymentActions from './payment.actions';

@Injectable()
export class PaymentEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private paymentService: PaymentService
  ) {}

  fetchPayments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaymentActions.fetchPayments),
      switchMap(() =>
        from(this.paymentService.getPayments()).pipe(
          map((payments) => PaymentActions.fetchPaymentsSuccess({ payments })),
          catchError((error) =>
            of(PaymentActions.fetchPaymentsFailed({ error }))
          )
        )
      )
    )
  );

  fetchCurrentPaymentById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaymentActions.fetchCurrentPaymentById),
      mergeMap(() => this.store.pipe(select(selectRouteState), take(1))),
      switchMap((route) => {
        const id = route.params['paymentId'];
        return from(this.paymentService.getById(id)).pipe(
          map((payment) =>
            PaymentActions.fetchCurrentPaymentByIdSuccess({ payment })
          ),
          catchError((error) =>
            of(PaymentActions.fetchCurrentPaymentByIdFailed({ error }))
          )
        );
      })
    )
  );

  fetchCurrentTransactionById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaymentActions.fetchCurrentTransactionById),
      mergeMap(() => this.store.pipe(select(selectRouteState), take(1))),
      switchMap((route) => {
        const transactionId = route.params['transactionId'];
        return from(this.paymentService.getTransactionById(transactionId)).pipe(
          map((transaction) =>
            PaymentActions.fetchCurrentTransactionByIdSuccess({ transaction })
          ),
          catchError((error) =>
            of(PaymentActions.fetchCurrentTransactionByIdFailed({ error }))
          )
        );
      })
    )
  );
}
